/* Vexoria Shop — scripts propios */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal() {
    var els = document.querySelectorAll('.vx-reveal:not(.vx-visible)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window) || reduce) {
      els.forEach(function (el) { el.classList.add('vx-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('vx-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function initContar() {
    var els = document.querySelectorAll('[data-vx-contar]:not([data-vx-ok])');
    if (!els.length) return;
    function animar(el) {
      var fin = parseFloat(el.getAttribute('data-vx-contar')) || 0;
      if (reduce || fin === 0) { el.textContent = fin; return; }
      var t0 = null, dur = 1400;
      function paso(t) {
        if (!t0) t0 = t;
        var p = Math.min((t - t0) / dur, 1), e = 1 - Math.pow(1 - p, 3);
        el.textContent = Math.round(fin * e);
        if (p < 1) requestAnimationFrame(paso);
      }
      requestAnimationFrame(paso);
    }
    els.forEach(function (el) {
      el.setAttribute('data-vx-ok', '1');
      if (!('IntersectionObserver' in window)) return;
      el.textContent = '0';
      var io = new IntersectionObserver(function (en) {
        en.forEach(function (x) { if (x.isIntersecting) { animar(x.target); io.unobserve(x.target); } });
      }, { threshold: 0.4 });
      io.observe(el);
    });
  }

  function parseFecha(s) {
    var m = String(s).trim().match(/^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{1,2}):(\d{2}))?$/);
    if (!m) return null;
    return new Date(+m[1], +m[2] - 1, +m[3], m[4] ? +m[4] : 23, m[5] ? +m[5] : 59, 59);
  }

  function initPromo() {
    document.querySelectorAll('[data-vx-promo-fin]').forEach(function (fila) {
      var fin = parseFecha(fila.getAttribute('data-vx-promo-fin'));
      var caja = fila.querySelector('[data-vx-cuenta]');
      if (!fin || !caja) return;
      function pintar() {
        var ms = fin - new Date();
        if (ms <= 0) { fila.hidden = true; return false; }
        fila.hidden = false;
        var d = Math.floor(ms / 864e5), h = Math.floor(ms / 36e5) % 24, mi = Math.floor(ms / 6e4) % 60, s = Math.floor(ms / 1e3) % 60;
        function c(n, l) { return '<span>' + (n < 10 ? '0' : '') + n + '<small>' + l + '</small></span>'; }
        caja.innerHTML = c(d, 'días') + c(h, 'horas') + c(mi, 'min') + c(s, 'seg');
        return true;
      }
      if (pintar()) { var iv = setInterval(function () { if (!pintar()) clearInterval(iv); }, 1000); }
    });
  }

  function sumarHabiles(desde, n) {
    var d = new Date(desde), k = 0;
    while (k < n) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) k++; }
    return d;
  }

  function initEntrega() {
    document.querySelectorAll('[data-vx-entrega]').forEach(function (el) {
      var min = parseInt(el.getAttribute('data-min'), 10) || 3, max = parseInt(el.getAttribute('data-max'), 10) || 7;
      var corte = parseInt(el.getAttribute('data-corte'), 10) || 0;
      var hoy = new Date();
      var f = { weekday: 'long', day: 'numeric', month: 'long' };
      var a = sumarHabiles(hoy, min).toLocaleDateString('es-CO', f), b = sumarHabiles(hoy, max).toLocaleDateString('es-CO', f);
      var t = el.querySelector('[data-vx-entrega-texto]');
      if (t) t.textContent = 'Pídelo hoy y recíbelo entre el ' + a + ' y el ' + b;
      var ct = el.querySelector('[data-vx-corte-texto]');
      if (ct && corte > 0) {
        var lim = new Date(hoy); lim.setHours(corte, 0, 0, 0);
        var w = hoy.getDay();
        if (w !== 0 && w !== 6 && hoy < lim) {
          var ms = lim - hoy, h = Math.floor(ms / 36e5), m = Math.floor(ms / 6e4) % 60;
          ct.textContent = 'Si pides en las próximas ' + h + ' h ' + m + ' min, sale en el despacho de hoy.';
        }
      } else if (ct) { ct.textContent = 'Tiempos estimados para ciudades principales. Pagas al recibir.'; }
    });
  }

  function initIrCompra() {
    document.querySelectorAll('[data-vx-ir-compra]').forEach(function (a) {
      if (a.getAttribute('href') !== '#MainContent') return;
      a.addEventListener('click', function (e) {
        var destino = document.querySelector('product-info, .product, [id^="MainProduct-"]');
        if (!destino) return;
        e.preventDefault();
        destino.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      });
    });
  }

  function initTodo() { initReveal(); initContar(); initPromo(); initEntrega(); initIrCompra(); }
  document.addEventListener('DOMContentLoaded', initTodo);
  document.addEventListener('shopify:section:load', initTodo);
})();
